import { Subject } from "rxjs";

export interface StatisticsOptions {
  date: Date;
  selectedHippodrome: any;
}

export const availableHippodromes: any[] = [];
export const availableRuns: any[] = [];

export const results: any[] = [];
export let shownRun: any = null;

export const dailyBulletin: any[] = [];

export let statisticsOptions: StatisticsOptions = {
  date: new Date(),
  selectedHippodrome: null,
};

export const hippodromesSubject = new Subject<any[]>();
export const statisticsSubject = new Subject();
export const shownRunSubject = new Subject();

export const statisticsOptionsSubject = new Subject<StatisticsOptions>();

export const handleOptionChanges = (date: Date, selectedHippodrome: any) => {
  statisticsOptions = { date, selectedHippodrome };
  statisticsOptionsSubject.next(statisticsOptions);
};

export const changeShownRun = (run: any) => {
  shownRun = run;
  shownRunSubject.next(shownRun);
};

export let activeTab: any = { key: null };
export const activeTabSubject = new Subject<any>();

export const changeTab = (tab: any) => {
  activeTab = tab;
  activeTabSubject.next(tab);
};
